exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".v-password[data-v-fac7605a]{position:relative;width:100%}.v-password input[data-v-fac7605a]{width:100%;padding:13px 20px;border:1px solid grey}.v-password svg[data-v-fac7605a]{position:absolute;top:50%;right:20px;-webkit-transform:translateY(-50%);-moz-transform:translateY(-50%);-ms-transform:translateY(-50%);-o-transform:translateY(-50%);transform:translateY(-50%);height:20px;max-height:60%;width:auto;z-index:2;cursor:pointer}.v-password svg .cls-1[data-v-fac7605a]{fill:#828282}.v-password svg .cls-2[data-v-fac7605a]{fill:#fff}.v-password svg.text #bar[data-v-fac7605a]{opacity:0}", ""]);

// exports
